import React from "react";
import ProgressBar from "../ProgressBar/ProgressBar";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '20px',
    paddingRight: '60px'
  },
  column: {
    display: 'flex',
    flexDirection: 'column'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  center: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  title: {
    paddingTop: '10px'
  },
  goalTarget: {
    paddingLeft: '10px'
  }
});

const Goals = ({ goals, totalProjectGoal }) => {
  console.log('debug: Goals -> goals', goals);
  const classes = useStyles();

  const currentProgressInEur = goals.reduce((cur, goal) => {
    return cur + (goal.progress || 0) * goal.goalTarget / 100;
  }, 0);
  const allGoals = goals.map((goal, index) => {

    return (
      <div key={index}>
        <div className={`${classes.row} ${classes.title}`}>
          <Typography>
            {goal.goal}:
          </Typography>
          <Typography className={classes.goalTarget}>
            <b>{goal.goalTarget}€</b>
          </Typography>
        </div>
        <div>
          <ProgressBar
            percentComplete={goal.progress || 0}
          />
        </div>
      </div>
    )
  }
  );
  console.log('debug: Goals -> currentProgressInEur', currentProgressInEur);
  console.log('debug: Goals -> totalProjectGoal', totalProjectGoal);

  return (
    <div className={classes.container}>
      <Typography variant="h6" className={classes.center}>
        Goals
      </Typography>
      <Typography variant="subtitle1" className={classes.center}>
        TOTAL PROGRESS (<b>{currentProgressInEur}€ / {totalProjectGoal}€</b>)
      </Typography>
      <ProgressBar
        percentComplete={currentProgressInEur / totalProjectGoal * 100}
        main={true}
      />
      <div className={classes.column}>
        {allGoals}
      </div>
    </div>
  );
}

export default Goals;
